import Vue from 'vue'
import newsletter from '../views/newsletter.vue'

export default {
    init() {
        if ($('#newsletter').length) {
            new Vue({
                el: '#newsletter',
                components: {
                    newsletter,
                },
            })
        }
    },
}
